import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";

import formatDate from "../../Components/dateFormatter";
import toast from "react-hot-toast";

import "./myaccount.css";
import apiRequest from "../../apiCall";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";

const MyAccount = () => {
  document.title = "My account - zerozero";
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [orderHistory, setorderHistory] = useState(false);
  const [selectedOrderDate, setSelectedOrderDate] = useState(
    new Date().getFullYear()
  );
  const [showPopup, setShowPopup] = useState(false);
  const [hoveredRowIndex, setHoveredRowIndex] = useState(-1);
  const [orderDetails, setOrderDetails] = useState();
  const [selectedOrderMasterId, setSelectedOrderMasterId] = useState(null); // Add this state
  const storedData = localStorage.getItem("userData") || " {}";
  const userData = JSON.parse(storedData);
  const FirstName = userData.FirstName;
  const LastName = userData.LastName;
  const id = userData.id || null;
  const [prevSelectedOrderDate, setPrevSelectedOrderDate] = useState(null);
  // const [showAllOrders, setShowAllOrders] = useState(false);
  const [showSecondTable, setShowSecondTable] = useState(false);
  const [showCancelOrder, setShowCancelOrder] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [buttonCaption, setButtonCaption] = useState("Show All Orders");

  const handleRowLeave = () => {
    setHoveredRowIndex(-1);
  };

  // ... (previous code)

  const handleButtonClick = () => {
    setShowTop10Orders((prevState) => !prevState);
    setButtonCaption((prevCaption) =>
      prevCaption === "Show All Orders"
        ? "Show Top 10 Orders"
        : "Show All Orders"
    );
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showTop10Orders, setShowTop10Orders] = useState(true);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getOrderData = () => {
    apiRequest(
      "GET",
      `/orderhistory/${id}/${selectedOrderDate}`,
      null,
      false,
      false
    )
      .then((response) => {
        dispatch(setLoading(true));
        const sortedOrderHistory = response.sort(
          (a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate)
        );
        setorderHistory(sortedOrderHistory);
        dispatch(setLoading(false));
      })

      .catch((error) => {
        console.log(error);
        dispatch(setLoading(false));
      });
  };
  useEffect(() => {
    if (
      selectedOrderDate !== prevSelectedOrderDate &&
      selectedOrderDate !== "disabled"
    ) {
      getOrderData();
      setPrevSelectedOrderDate(selectedOrderDate);
    }
  }, [selectedOrderDate, prevSelectedOrderDate, id]);

  const cancelOrderPopup = (orderMasterId) => {
    setShowCancelOrder(true);
    setCancelReason("");
    setSelectedOrderMasterId(orderMasterId);
  };

  const closeOrderPopup = () => {
    setShowCancelOrder(false);
    setSelectedOrderMasterId("");
  };

  const cancelOrder = () => {
    if (cancelReason != "") {
      const onlineOrderMaster = {
        CustomerId: id,
        onlineOrderMasterId: selectedOrderMasterId,
        updatedDate: orderHistory.filter(
          (x) => x.OnlineOrderMasterId == selectedOrderMasterId
        )[0]?.UpdatedDate,
        remarks: cancelReason,
      };
      apiRequest(
        "POST",
        "cancelOnlineOrderData",
        onlineOrderMaster,
        false,
        false
      )
        .then((res) => {
          dispatch(setLoading(true));
          if (res.isSuccess) {
            setShowCancelOrder(false);
            setSelectedOrderMasterId("");
            setCancelReason("");
            toast.success("Order cancelled!!!");
            getOrderData();
            dispatch(setLoading(false));
          } else {
            toast.error("Something went wrong. Please Try Again!!!");
            dispatch(setLoading(false));
          }
        })
        .catch((error) => {
          console.log("Cancel order error", error);
          dispatch(setLoading(false));
        });
    }
  };

  const openPopup = (orderMasterId) => {
    setShowPopup(true);
    setSelectedOrderMasterId(orderMasterId);
    apiRequest("GET", `/orderdetails/${orderMasterId}`, null, false, false)
      .then((response) => {
        dispatch(setLoading(true));
        setOrderDetails(response);
        dispatch(setLoading(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(setLoading(false));
      });
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleRowHover = (index) => {
    setHoveredRowIndex(index);
  };

  return (
    <div className="my-orders">
      <div className="cont">
        <div className="cont-order">
          <h1>My Orders</h1>

          <div style={{}}>
            <button onClick={handleButtonClick} className="my-order-btn">
              {buttonCaption}
            </button>
          </div>
        </div>
        <br />
        <main>
          <div className="rs">
            {selectedOrderDate && (
              <>
                {/* First Table: Order History */}
                {windowWidth > 900 && (
                  <>
                    {!showSecondTable && (
                      <>
                        {orderHistory.length > 0 ? (
                          <table className="myorder-table">
                            <tbody>
                              <tr>
                                <th style={{ width: "10%" }}>Order On</th>
                                <th>Ship To</th>
                                <th>Contact Person</th>
                                <th>Order Number</th>
                                <th>Order Status</th>
                                <th>Reason</th>
                              </tr>
                              {orderHistory
                                .slice(0, showTop10Orders ? 10 : undefined)
                                .map((item, index) => (
                                  <tr
                                    className="table-row"
                                    key={index}
                                    onMouseEnter={() => handleRowHover(index)}
                                    onMouseLeave={handleRowLeave}
                                  >
                                    <td>
                                      {formatDate(item.CreatedDate)}
                                      <br />
                                    </td>

                                    <td>
                                      {item.CustomerDetails && (
                                        <p>
                                          {
                                            JSON.parse(item.CustomerDetails)
                                              ?.address
                                          }
                                        </p>
                                      )}
                                    </td>
                                    <td>
                                      {item.CustomerDetails && (
                                        <h4>
                                          {
                                            JSON.parse(item.CustomerDetails)
                                              ?.firstName
                                          }{" "}
                                          {
                                            JSON.parse(item.CustomerDetails)
                                              ?.lastName
                                          }
                                        </h4>
                                      )}
                                    </td>
                                    <td>
                                      <h4>{item.OrderNumber}</h4>
                                      <br />
                                      <h4
                                        onClick={() =>
                                          openPopup(item.OnlineOrderMasterId)
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "green",
                                        }}
                                      >
                                        Order Details
                                      </h4>
                                    </td>
                                    <td>
                                      <h4>{item.StatusName}</h4>
                                      {(item.StatusName === "Pending" ||
                                        item.StatusName === "Accepted") && (
                                        <button
                                          className="my-order-btn"
                                          onClick={() =>
                                            cancelOrderPopup(
                                              item.OnlineOrderMasterId
                                            )
                                          }
                                        >
                                          Cancel
                                        </button>
                                      )}
                                    </td>
                                    <td>{item.Reason}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        ) : (
                          <div>
                            <h1>No Order History</h1>
                          </div>
                        )}
                      </>
                    )}

                    {showSecondTable && (
                      <>
                        {orderHistory.length > 0 ? (
                          <table className="order-table">
                            <tbody>
                              <tr>
                                <th style={{ width: "10%" }}>Order On</th>
                                <th>Ship To</th>
                                <th>Contact Person</th>
                                <th>Order Number</th>
                                <th>Order Status</th>
                                <th>Reason</th>
                              </tr>
                              {orderHistory
                                .slice(showTop10Orders ? 10 : 0)
                                .map((item, index) => (
                                  <tr
                                    className="table-row"
                                    key={index}
                                    onMouseEnter={() => handleRowHover(index)}
                                    onMouseLeave={handleRowLeave}
                                  >
                                    <td>
                                      {formatDate(item.CreatedDate)}
                                      <br />
                                    </td>

                                    <td>
                                      {item.CustomerDetails && (
                                        <p>
                                          {
                                            JSON.parse(item.CustomerDetails)
                                              ?.address
                                          }
                                        </p>
                                      )}
                                    </td>
                                    <td>
                                      {item.CustomerDetails && (
                                        <h4>
                                          {
                                            JSON.parse(item.CustomerDetails)
                                              ?.firstName
                                          }{" "}
                                          {
                                            JSON.parse(item.CustomerDetails)
                                              ?.lastName
                                          }
                                        </h4>
                                      )}
                                    </td>
                                    <td>
                                      <h4>{item.OrderNumber}</h4>
                                      <br />
                                      <h4
                                        onClick={() =>
                                          openPopup(item.OnlineOrderMasterId)
                                        }
                                        style={{
                                          cursor: "pointer",
                                          color: "green",
                                        }}
                                      >
                                        Order Details
                                      </h4>
                                    </td>
                                    <td>
                                      <h4>{item.StatusName}</h4>

                                      {(item.StatusName === "Pending" ||
                                        item.StatusName === "Accepted") && (
                                        <button
                                          className="my-order-btn"
                                          onClick={() =>
                                            cancelOrderPopup(
                                              item.OnlineOrderMasterId
                                            )
                                          }
                                        >
                                          Cancel
                                        </button>
                                      )}
                                    </td>
                                    <td>{item.Reason}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        ) : (
                          <div>
                            <h1>No Order History</h1>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}

                {windowWidth <= 900 && (
                  <>
                    {/* Card View for First Table */}
                    {orderHistory.length > 0 && !showSecondTable && (
                      <div className="my-order-card-container">
                        {orderHistory
                          .slice(0, showTop10Orders ? 10 : undefined)
                          .map((item, index) => (
                            <div className="my-order-card" key={index}>
                              <div className="my-order-card-header">
                                <h3>Order On</h3>
                                <h4>{formatDate(item.CreatedDate)}</h4>
                                <h4>Status: {item.StatusName}</h4>
                              </div>
                              <div className="my-order-card-details">
                                {item.CustomerDetails && (
                                  <p>
                                    Ship To:{" "}
                                    {JSON.parse(item.CustomerDetails)?.address}
                                  </p>
                                )}
                                {item.CustomerDetails && (
                                  <p>
                                    Contact Person:{" "}
                                    {
                                      JSON.parse(item.CustomerDetails)
                                        ?.firstName
                                    }{" "}
                                    {JSON.parse(item.CustomerDetails)?.lastName}
                                  </p>
                                )}
                                <p>Order Number: {item.OrderNumber}</p>
                                <p>Reason: {item.Reason}</p>
                              </div>
                              <div className="my-order-card-actions">
                                <button
                                  className="my-order-btn"
                                  onClick={() =>
                                    openPopup(item.OnlineOrderMasterId)
                                  }
                                >
                                  Order Details
                                </button>
                                {["Pending", "Accepted"].includes(
                                  item.StatusName
                                ) && (
                                  <button
                                    className="my-order-btn"
                                    onClick={() =>
                                      cancelOrderPopup(item.OnlineOrderMasterId)
                                    }
                                  >
                                    Cancel
                                  </button>
                                )}
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                    {orderHistory.length === 0 && !showSecondTable && (
                      <h1>No orders available</h1>
                    )}

                    {/* Card View for Second Table */}
                    {showSecondTable && (
                      <div className="my-order-card-container">
                        {orderHistory
                          .slice(showTop10Orders ? 10 : 0)
                          .map((item, index) => (
                            <div className="my-order-card" key={index}>
                              {/* Existing card view code */}
                              {/* Example: */}
                              <div className="my-order-card-header">
                                <h3>Order On</h3>
                                <h4>{formatDate(item.CreatedDate)}</h4>
                                <h4>Status: {item.StatusName}</h4>
                              </div>
                              <div className="my-order-card-details">
                                {item.CustomerDetails && (
                                  <p>
                                    Ship To:{" "}
                                    {JSON.parse(item.CustomerDetails)?.address}
                                  </p>
                                )}
                                {item.CustomerDetails && (
                                  <p>
                                    Contact Person:{" "}
                                    {
                                      JSON.parse(item.CustomerDetails)
                                        ?.firstName
                                    }{" "}
                                    {JSON.parse(item.CustomerDetails)?.lastName}
                                  </p>
                                )}
                                <p>Order Number: {item.OrderNumber}</p>
                                <p>Reason: {item.Reason}</p>
                              </div>

                              <div className="my-order-card-actions">
                                <button
                                  className="my-order-btn"
                                  onClick={() =>
                                    openPopup(item.OnlineOrderMasterId)
                                  }
                                >
                                  Order Details
                                </button>
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </main>
      </div>

      {showPopup && selectedOrderMasterId && orderDetails && (
        <div className="orderDeatils">
          <button className="orderDetailsClose" onClick={closePopup}>
            X
          </button>
          <br />
          <table>
            <tbody>
              <tr>
                <th>Brand</th>
                <th>Price Per Unit</th>
                <th>Quantity</th>
              </tr>
              {Object.entries(orderDetails).map(([key, item], index) => (
                <tr
                  className="table-row"
                  key={key}
                  onMouseEnter={() => handleRowHover(index)}
                  onMouseLeave={handleRowLeave}
                >
                  <td>
                    {item.Brand} ({item.Pack} {item.StaticName})
                  </td>
                  <td>₹ {item.PricePerUnit}</td>
                  <td>{item.quantity}</td>
                </tr>
              ))}
            </tbody>
            <br />
          </table>
          <span>Total Price: ₹ {orderDetails[0].TotalPrice}</span>
        </div>
      )}

      {showCancelOrder && selectedOrderMasterId && (
        <div className="orderDeatils">
          <button className="orderDeatilsClose" onClick={closeOrderPopup}>
            X
          </button>
          <br />
          <p style={{ fontSize: "20px", fontWeight: "900" }}>
            Write a reason for cancel order
          </p>
          <div>
            <div style={{ marginBottom: "10px" }}>
              <textarea
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  height: "100px",
                  resize: "none",
                  paddingLeft: "0.3rem",
                }}
                id="message"
                placeholder="Write a reason"
                name="message"
                maxLength={400}
                required
                value={cancelReason}
                onChange={(e) => {
                  setCancelReason(e.target.value);
                }}
              />
              {/* {errors.message && <div className="err">{errors.message}</div>} */}
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button className="my-order-btn" onClick={cancelOrder}>
                Cancel Order
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyAccount;
